var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "entrance-container flex justify-center items-center" },
    [
      _c(
        "a",
        {
          staticClass: "item m-r-36",
          attrs: {
            href: _vm.signUpHref,
            target: "_blank",
            rel: "noopener noreferrer",
          },
        },
        [
          _c(
            "div",
            { staticClass: "image" },
            [
              _c("el-image", {
                staticStyle: { width: "93px", height: "85px" },
                attrs: { src: _vm.singUp },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "font-30 font-weight text-000" }, [
            _vm._v("网上报名"),
          ]),
        ]
      ),
      _c(
        "a",
        {
          staticClass: "item m-r-36",
          attrs: {
            href: _vm.printHref,
            target: "_blank",
            rel: "noopener noreferrer",
          },
        },
        [
          _c(
            "div",
            { staticClass: "image" },
            [
              _c("el-image", {
                staticStyle: { width: "101px", height: "85px" },
                attrs: { src: _vm.print },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "font-30 font-weight text-000" }, [
            _vm._v("准考证打印"),
          ]),
        ]
      ),
      _c(
        "a",
        {
          staticClass: "item",
          attrs: {
            href: _vm.adminHref,
            target: "_blank",
            rel: "noopener noreferrer",
          },
        },
        [
          _c(
            "div",
            { staticClass: "image" },
            [
              _c("el-image", {
                staticStyle: { width: "101px", height: "85px" },
                attrs: { src: _vm.login },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "font-30 font-weight text-000" }, [
            _vm._v("考务管理"),
          ]),
        ]
      ),
      _c("exam-dialog", { ref: "examDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }